import { User, LottoBetpanelService } from "baseline-lib";
import { Subject } from "rxjs";

export class Global {
    // public baseUrl = 'https://indusapi.demowebapps.com';
    // public baseUrls = 'http://indusapi.demowebapps.com';
    // public version= '/v1/'
    // public apiUrl=this.baseUrl+'/index.php'+this.version;
    public isLoggedIn : boolean = false;
    public selectedMenu : string ='home';
    public selectedGameId : number = 0;
    public authUser :User = new User();
    public currentTimer: Date;
    public _imageUrl: string;
    public isfromrapid : boolean = false;
    public gameMode : string = 'sports';
    //public subject = new Subject<String>();;
    public sundaybaffleid;
    public inPlay : boolean = false;
    public isBetAdded : boolean = false;
    public isLoaderShownHomepage : boolean = false;
    public isLoaderShowninDetailPage : boolean = false;
    public hideHomeLoader : boolean = false; 
}


// WEBPACK FOOTER //
// ./src/global/global.ts